export default "__VITE_ASSET__Cey3SxEX__"